import ProfileAdvancedView from './ProfileAdvancedView'
export default ProfileAdvancedView
